/**
 * The lines the bet covers (decision 56): the player plays 1, 2 or 3 of the base rows — 1 the middle row, 2 the top two,
 * 3 all three — and a spin costs a line's bet times the lines. Every row rolls and lands; only an active line starts the
 * bonus, and only a coin in an active row carries a gem. The bonus itself plays the whole board, whatever the lines.
 * Shared by the offline server (the rules) and the presentation (the rows it lights and frames).
 */
export const LINE_OPTIONS: readonly number[] = [1, 2, 3];

/** The count the offline boot starts with: one line, the middle row (the user, 2026-10-06). */
export const INITIAL_LINES = 1;

const ROWS_BY_LINES: Readonly<Record<number, readonly number[]>> = { 1: [1], 2: [0, 1], 3: [0, 1, 2] };

/** The base rows `lines` lines cover. */
export function lineRows(lines: number): readonly number[] {
  const rows = ROWS_BY_LINES[lines];
  if (!rows) throw new Error(`lineRows: ${lines} lines are not offered (${LINE_OPTIONS.join(", ")})`);
  return rows;
}
